// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.opening-hours ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.opening-hours ul li {
  padding: 1px 0;
  font-family: var(--font-family-montserrat);
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.04em;
}
.opening-hours ul li:last-child {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/working-hours-modal/working-hours-modal.component.scss"],"names":[],"mappings":"AAGC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AAFF;AAIE;EACC,cAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAFH;AAIG;EACC,mBAAA;AAFJ","sourcesContent":["@import '../../../theme/mixins';\n\n.opening-hours {\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\n\t\tli {\n\t\t\tpadding: 1px 0;\n\t\t\tfont-family: var(--font-family-montserrat);\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 14px;\n\t\t\tletter-spacing: 0.04em;\n\n\t\t\t&:last-child {\n\t\t\t\tborder-bottom: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
